import React, { useState } from 'react';
import DashboardSideMenu from '../../DashboardReuseAbleComponents/DashboardSideMenu';
import SettingContactBtnHeader from './SettingContactBtnHeader';
import SettingContactInfoForm from './SettingContactInfoForm';
import SettingContactMessages from './SettingContactMessages';

// Styles
import styles from "./../Settings.module.css";


const SettingContact = () => {

    const [filterSettingContact, setFilterSettingContact] = useState({
        info: true,
        messages: false
    })

    const changeFilterContactHandler = (name) => {
        if (name === "info") {
            setFilterSettingContact((prev) => {
                return { ...prev, info: true, messages: false };
            });
        } else if (name === "messages") {
            setFilterSettingContact((prev) => {
                return { ...prev, messages: true, info: false };
            });
        }
    }

    return (
        <>
            <div className='container-fluid'>
                <div className='row'>
                    <div className="col-md-9" >
                        <div className={`mt-3 px-0 ${styles.file_cards_container}`}>
                            <SettingContactBtnHeader
                                filterSettingContact={filterSettingContact}
                                changeFilterContactHandler={changeFilterContactHandler}
                            />

                            {filterSettingContact.info && <SettingContactInfoForm />}
                            {filterSettingContact.messages && <SettingContactMessages />}
                        </div>
                    </div>
                    <div className='col-md-3'>
                        {/* sideMenu starts */}
                        <DashboardSideMenu />
                        {/* sideMenu ends */}
                    </div>
                </div>
            </div>
        </>
    )

}

export default SettingContact;